export default `Name,Population
Arica and Parinacota,226068
Tarapacá,330558
Antofagasta,607534
Atacama,286168
Coquimbo,757586
Valparaíso,1815902
Santiago,7112808
O'Higgins,914555
Maule,1044950
Ñubl,480609
Biobío,1556805
Araucanía,957224
Los Ríos,384837
Los Lagos,828708
Aysén,103158
Magallanes,166533`